module.exports = "/_next/static/images/metaverse-bee6d12d05e3e2cb91a0fffddeb938ab.png";